<div class="loader-section">
    <div class="loader" [ngStyle]="{ 'font-size': diameter() + 'px' }"></div>
    <p class="caption">Loading Please wait...</p>
</div>